<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Kontakte</h4>
  <button type="button"
          class="btn-close"
          aria-describedby="modal-title"
          (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body" (keyup.enter)="SaveEntry()">
  @if(Auftrag != null)
  {
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Artikel Name</th>
        <th scope="col">Artikel Nr.</th>
        <th scope="col">Anzahl</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      @for (artikel of Auftrag.auftragArtikel; track artikel.artikel?.artnr; let i = $index) {
      <tr>
        <td>
          {{ artikel.artikel?.name }}
        </td>
        <td>
          {{ artikel.artikel?.artnr }}
        </td>
        <td>
          {{ artikel.anzahl }}
        </td>
        <td>
          <i class="btn btn-danger btn-sm bi bi-person-dash-fill" (click)="DeleteEntry(artikel.artikel.artnr)"></i>
        </td>
      </tr>
      }
    </tbody>
  </table>
  }


  <hr />

  @if(ArtikelList != null)
  {
  <div class="row">
    <div class="col">
      <div class="form-floating mb-3">
        <select [compareWith]="compareFn"
                [ngModel]="SelectedArtikel"
                (ngModelChange)="onValueChange($event)"
                class="form-select">

          <option [ngValue]="null">Bitte wählen...</option>

          @for (item of FilterArtikelList; track item.key) {
          <option [ngValue]="item">
            {{ item.name }}
          </option>
          }
        </select>
        <label for="Pflegegruppe">Pflegegruppe</label>
      </div>
    </div>
    <div class="col">
      <div class="form-floating mb-3">
        <input type="number" class="form-control" id="Anzahl" [(ngModel)]="anzahl" min="1">
        <label for="Nachname">Anzahl</label>
      </div>
    </div>
  </div>
  }

  <div class="row">
    <div class="col">
      <div class="btn btn-primary" (click)="SaveEntry()">Speichern</div>
    </div>
  </div>

</div>
